import AlloyFinger from 'alloyfinger'
import Transform from 'css3transform'

class Sprites {
  constructor ({ el, stage, proxyEl }) {
    this.el = el
    this.stage = stage
    this.proxyEl = proxyEl

    this.x = 0
    this.y = 0
    this.scale = 1
    this.rotate = 0
    this.width = el.naturalWidth
    this.height = el.naturalHeight
    this.boxWidth = stage.clientWidth
    this.boxHeight = stage.clientHeight
    this.initScale = 1
    this.touch = null

    this.init()
  }
  init () {
    Transform(this.el)
    this.x = this.el.translateX = (this.boxWidth / 2) - (this.width / 2)
    this.y = this.el.translateY = (this.boxHeight / 2) - (this.height / 2)
    if (this.width > this.boxWidth) {
      this.scale = this.el.scaleX = this.el.scaleY = this.initScale = parseFloat((this.boxWidth / this.width).toFixed(2))
    }
    while (this.stage.firstChild) {
      this.stage.removeChild(this.stage.firstChild)
    }
    this.stage.appendChild(this.el)
    this.touch = new AlloyFinger((this.proxyEl || this.stage), {
      pinch: this.pinch.bind(this),
      multipointStart: this.multipointStart.bind(this),
      pressMove: this.pressMove.bind(this),
      rotate: this.rotateFn.bind(this)
    })
  }
  pinch (evt) {
    this.scale = this.initScale * evt.zoom
    this.el.scaleX = this.el.scaleY = this.scale
  }
  multipointStart (evt) {
    this.initScale = this.el.scaleX
  }
  pressMove (evt) {
    this.x += evt.deltaX
    this.y += evt.deltaY
    this.el.translateX = this.x
    this.el.translateY = this.y
    evt.preventDefault()
  }
  rotateFn (evt) {
    this.rotate += evt.angle
    this.el.rotateZ = this.rotate
  }
}

export default Sprites
